import { useState, useEffect, useCallback } from 'react';
import { getRotas } from '@spark/services';
import { notification } from '@spark/ui-components/utils/notification';

export const useRotaSelection = (show) => {
  const [rotas, setRotas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtros, setFiltros] = useState({ Ativo: '1' });
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(10);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const carregarRotas = useCallback(async () => {
    try {
      setLoading(true);

      const params = {
        ...filtros,
        Ativo: '1',
        pagina: paginaAtual,
        quantidadePorPagina,
      };

      const response = await getRotas(params);
      const dados = response?.registros || response?.Registros || [];
      const total = response?.totalRegistros || response?.TotalRegistros || 0;

      setRotas(dados);
      setTotalRegistros(total);
    } catch (error) {
      console.error('Erro ao carregar rotas:', error);
      notification.error(
        error?.message || 'Nao foi possivel carregar as rotas',
        'Erro ao carregar rotas'
      );
      setRotas([]);
      setTotalRegistros(0);
    } finally {
      setLoading(false);
    }
  }, [filtros, paginaAtual, quantidadePorPagina]);

  useEffect(() => {
    if (show) {
      carregarRotas();
    }
  }, [show, carregarRotas]);

  const handleFiltrosChange = useCallback((novosFiltros) => {
    setFiltros({ ...novosFiltros, Ativo: '1' });
    setPaginaAtual(1);
  }, []);

  const handlePaginationChange = useCallback((paginationState) => {
    if (paginationState.pageSize !== quantidadePorPagina) {
      setQuantidadePorPagina(paginationState.pageSize);
      setPaginaAtual(1);
    } else if (paginationState.pageIndex !== undefined) {
      setPaginaAtual(paginationState.pageIndex + 1);
    }
  }, [quantidadePorPagina]);

  return {
    rotas,
    loading,
    paginaAtual,
    quantidadePorPagina,
    totalRegistros,
    handleFiltrosChange,
    handlePaginationChange,
  };
};
